import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let trigger = null;

const getMove = (track) => track.scrollWidth - window.innerWidth;

const getStickyHeight = (wrap) => {
  const sticky = wrap.querySelector('.js-hscroll-sticky');
  if (!sticky) return 0;
  const trackH = wrap.querySelector('.js-hscroll-track')?.offsetHeight || 0;
  return sticky.offsetHeight - trackH;
};

const setWrapHeight = (wrap, track) => {
  wrap.style.height = `${window.innerHeight + getMove(track) + getStickyHeight(wrap)}px`;
};

const SideScroll = () => {
  const wrap = document.querySelector('.js-hscroll-wrap');
  if (!wrap) return;

  const track = wrap.querySelector('.js-hscroll-track');
  if (!track) return;

  setWrapHeight(wrap, track);

  trigger = gsap.to(track, {
    x: () => -getMove(track),
    ease: 'none',
    scrollTrigger: {
      trigger: wrap,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 1.2,
      invalidateOnRefresh: true,
    },
  });
};

const SideScrollResize = () => {
  const wrap = document.querySelector('.js-hscroll-wrap');
  if (!wrap) return;

  const track = wrap.querySelector('.js-hscroll-track');
  if (!track) return;

  setWrapHeight(wrap, track);
  ScrollTrigger.refresh();
};

const SideScrollSP = () => {
  const wrap = document.querySelector('.js-hscroll-wrap');
  if (!wrap) return;

  const track = wrap.querySelector('.js-hscroll-track');
  if (!track) return;

  const mm = gsap.matchMedia();

  mm.add('(max-width: 767.9px)', () => {
    setWrapHeight(wrap, track);

    gsap.to(track, {
      x: () => -getMove(track),
      ease: 'none',
      scrollTrigger: {
        trigger: wrap,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1.2,
        invalidateOnRefresh: true,
      },
    });

    // PC幅に変わったらリセット
    return () => {
      wrap.style.height = '';
      gsap.set(track, { x: 0 });
    };
  });
};

const SideScrollSPResize = () => {
  const wrap = document.querySelector('.js-hscroll-wrap');
  if (!wrap) return;

  const track = wrap.querySelector('.js-hscroll-track');
  if (!track) return;

  if (window.innerWidth < 768) {
    setWrapHeight(wrap, track);
  } else {
    wrap.style.height = '';
  }
  ScrollTrigger.refresh();
};

export default SideScroll;
export { SideScrollResize, SideScrollSP, SideScrollSPResize };
